import React from 'react';
import { PaymentCardsOnboardingDialogContext } from './Context';

export const usePaymentCardsOnboardingDialog = () => {
    const context = React.useContext(PaymentCardsOnboardingDialogContext);
    if (!context) {
        throw new Error('Missing the PaymentCardsOnboardingDialog!');
    }
    return context;
};
